export const randomString = (length = 16): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return new Array(length)
    .fill('')
    .map((_): string => characters.charAt(Math.floor(Math.random() * characters.length)))
    .join('');
};
